export const GLOBAL_STATE = 'ReadersClub'

export const CLUB_EVENT_CREATE = 'CLUB_EVENT_CREATE'
export const CLUB_EVENT_DELETE = 'CLUB_EVENT_DELETE'
export const CLUB_EVENT_LIST = 'CLUB_EVENT_LIST'
export const CLUB_EVENT_CHANGE_STATUS = 'CLUB_EVENT_CHANGE_STATUS'
